<template>
    <div>
        <div class="card">
            <div class="card-header animated fadeInRightBig" >
                <div class="card-title">Solicitação de marcação</div>      
            </div>
            <div class="card-body">
                <div class="row mb-3">
                     <div class="col-md-6">
                        <label><span class="required">*</span> Data e hora</label>
                        <date-time 
                            v-model="checkRequest.datetime"
                            format="YYYY-MM-DD HH:mm:ss"
                            formatted="DD/MM/YYYY HH:mm:ss"
                            output-format="YYYY-MM-DD HH:mm:ss"
                            :no-button-now="true"
                        >
                            <input type="text" class='form-control' :value="checkRequest.datetime">
                        </date-time>
                    </div>
                    <div class="col-md-6">
                        <label>Anexo</label>
                        <input type="file" class='form-control' id="file">
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12">
                        <label><span class="required">*</span> Justificativa</label>
                        <textarea rows="5" class='form-control' v-model='checkRequest.justification'></textarea>
                    </div>
                </div>
                <div class="block text-right">
                    <router-link to="/checkRequests" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <p><span class="required">*</span> Campos Obrigatórios</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                users: [],
                checkRequest: {
                    datetime: '',
                    justification: '',
                }
            }
        },
        methods: {
            save: function () {
                const self = this;

                if(self.checkRequest.id) return self.edit();

                const api = this.$store.state.api + 'checkrequests';

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Solicitação de marcação cadastrada com sucesso`, 'success');
                        this.$router.push('/checkRequests');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            edit: function () {
                const self = this;
                const api = self.$store.state.api + 'checkrequests/' + self.checkRequest.id;

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Solicitação de marcação editada com sucesso`, 'success');
                        this.$router.push('/checkRequests');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            makeFormData: function(){
                const self = this;
                let fd  = new FormData();

                fd.append('datetime', self.checkRequest.datetime);
                fd.append('justification', self.checkRequest.justification);

                let file = document.getElementById('file').files[0]
                if(file) {
                    fd.append('file', file);
                }

                if(self.checkRequest.id) {
                    fd.append('id', self.checkRequest.id);
                    fd.append('_method', 'PUT');
                }

                return fd;
            },
            getCheckRequest: function(id){
                let self = this;
                let api  = self.$store.state.api + 'checkrequests/' + id

                self.$http.get(api)
                    .then((response) => {
                        self.checkRequest = response.data.data[0]
                    })
                    .catch((error) => {
                        self.errors = error.response.data;
                        self.$message(null, self.errors, 'error');
                    });
            },
        },
        mounted: function(){
            const self = this;

            let id = self.$route.params.id;
            if(id) {
                self.getCheckRequest(id);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/CheckRequest/Add.vue